import React from 'react';
import { Flex, Text, Heading, Button } from 'rebass';
import Field from 'components/Field';
import LabelAsterisk from 'components/LabelAsterisk';
import Label from 'components/Label';

interface JobPositionStepProps {
  values: any;
  handleSubmit: any;
  hasValidationErrors: boolean;
  setNextFormStepHandler: any;
}

const JobPositionStep: React.FC<JobPositionStepProps> = (props): JSX.Element => {
  const { values, handleSubmit, hasValidationErrors, setNextFormStepHandler } = props;
  return (
    <Flex flexDirection="column" alignItems="center" py={7}>
      <Heading fontSize={['20px']} fontWeight={6} mb={5}>
        What position are you hiring for?
      </Heading>
      <Field
        name="title"
        label="Position Title"
        inputType="text"
        placeholder="Developer"
        required
        labelAsterisk
      />
      <Field
        name="type"
        label="Position Type"
        inputType="select"
        selectOptions={['Contract', 'Permanent']}
        required
        labelAsterisk
      />
      <Flex width="100%" flexDirection="column" css="max-width: 400px;">
        <Flex>
          <Label htmlFor="minSalary">
            {(() => {
              switch (values.type) {
                case 'Contract':
                  return 'Salary range per hour';
                case 'Permanent':
                  return 'Salary range per year';
                default:
                  return 'Salary range';
              }
            })()}
          </Label>
          <LabelAsterisk />
        </Flex>
        <Flex
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          mb="20px"
          css="max-width: 400px"
        >
          <Field
            name="minSalary"
            inputType="number"
            numberInputMin={1}
            width="175px"
            mb="0px"
            required
            validate={(value: string, currentValues: any) =>
              +value >= +currentValues.maxSalary ? 'Value too high' : undefined
            }
          />
          <Text fontSize="18px" fontWeight={700}>
            to
          </Text>
          <Field
            name="maxSalary"
            inputType="number"
            numberInputMin={values.minSalary}
            width="175px"
            mb="0px"
            required
          />
        </Flex>
      </Flex>
      <Heading fontSize={['20px']} fontWeight={6} my={1}>
        Location
      </Heading>
      <Field
        name="country"
        label="Country"
        inputType="select"
        selectOptions={['USA', 'Canada']}
        required
        labelAsterisk
      />
      <Field
        name="state"
        label="Province-State"
        inputType="text"
        placeholder="BC"
        required
        labelAsterisk
        pattern="[A-Z]{2}"
        patternMismatch="Needs to be 2 capital letters"
      />
      <Field
        label="City"
        name="city"
        inputType="text"
        placeholder="Type here"
        required
        labelAsterisk
      />
      <Heading fontSize={['20px']} fontWeight={6} mb={2}>
        Indicate the top three skills required
      </Heading>
      <Field name="firstSkill" inputType="text" placeholder="Type here" required />
      <Field name="secondSkill" inputType="text" placeholder="Type here" required />
      <Field name="thirdSkill" inputType="text" placeholder="Type here" required />
      <Button
        variant="primary"
        mt={2}
        onClick={hasValidationErrors ? handleSubmit : setNextFormStepHandler}
      >
        Next
      </Button>
    </Flex>
  );
};

export default JobPositionStep;
